import { render, staticRenderFns } from "./expenses_report.vue?vue&type=template&id=2a56e72c&"
import script from "./expenses_report.vue?vue&type=script&lang=js&"
export * from "./expenses_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports